import { RefObject } from 'react';

import BaseTextArea from 'components/Input/InputField/BaseInputField/BaseTextAreaField';
import { BaseInputFieldProps } from 'components/Input/InputField/BaseInputField/types';
import BaseInput from './BaseInputField/BaseInputField';

type BaseInputProps = BaseInputFieldProps;
type BaseTextAreaProps = BaseInputFieldProps & Partial<{ ref: RefObject<HTMLElement> }>;

const InputField = (props: BaseInputProps & BaseTextAreaProps) => {
  const { multiline, ...baseInputFieldProps } = props;

  return multiline ? (
    <BaseTextArea {...(baseInputFieldProps as BaseTextAreaProps)} />
  ) : (
    <BaseInput {...(baseInputFieldProps as BaseInputProps)} />
  );
};

export default InputField;
